<template>
<div class="mb-2 " >

<div class="grid p-0 m-0">

<div class="col-11" @click="gotoCondition">
<p class="p-link py-2">
<template  v-if="line.inputfield.type=='number'">
	<span>Girilen değer</span>
	
</template>


<template  v-if="line.inputfield.type=='select' || line.inputfield.type=='multiselect'">
	<span>Seçilen değer</span>
	<span class="text-primary pl-1"><b> {{line.selectedinputfieldoption.name}} </b></span>
	<span class="pl-1">ise, </span>
</template>




<!-- section affected-->
<template v-if="line.affected_item_type=='section'">
	<span class="text-primary  pl-1"><b>{{line.affectedsection.name}} bölümü, </b></span>
	<span class="pl-1"><b class="text-primary">Puanını</b></span>
	<span class="pl-1 text-primary"><b>{{line.selected_item_altered_points}}</b></span>
		<span class="pl-1">{{pointoptions}}</span>
</template>
<!-- section affected-->



<!-- inputfield affected-->
<template v-if="line.affected_item_type=='inputfield'">
	<span class="text-primary  pl-1"><b>{{line.affectedinputfield.name}} sorusu, </b></span>

	<span v-html="conditionval"></span>
	<span class=" pl-1"><b class="text-primary">{{ booleanval}}</b></span>

	<template v-if="line.selected_inputfield_switch=='points'">
		<span class="pl-1 text-primary"><b>{{line.selected_item_altered_points}}</b></span>
		<span class="pl-1">{{pointoptions}}</span>

	</template>
	<template v-else>
		<span class="pl-1">olarak güncelle</span>
	</template>
	



</template>
<!-- inputfield affected-->



<!-- custom_attribute affected-->
<template v-if="line.affected_item_type=='custom_attribute'">
	<template v-if="line.affectedcustomattribute.type=='select'">
	<span class="text-primary pr-1 pl-1"><b>{{line.affectedcustomattribute.name}}</b></span>
	<span>özelliğini</span>
	<span class="text-primary  pl-1"><b>{{selected_custom_attribute_option.name}}</b></span>
	</template>

	

	<template v-if="line.affectedcustomattribute.type=='number'">
		<span class="text-primary pr-1 pl-1"><b>{{line.affectedcustomattribute.name}}</b></span>
	<span>özelliğini</span>
	<span class="text-primary pr-1 pl-1"><b>{{line.selected_customattribute_number_val}}</b></span>
	</template>

	<template v-if="line.affectedcustomattribute.type=='string'">
		<span class="text-primary pr-1 pl-1"><b>{{line.affectedcustomattribute.name}}</b></span>
	<span>özelliğini</span>
	<span class="text-primary pr-1 pl-1"><b>{{line.selected_customattribute_text_val}}</b></span>
	</template>

	<template v-if="line.affectedcustomattribute.type=='boolean'">
		<span class="text-primary pr-1 pl-1"><b>{{line.affectedcustomattribute.name}}</b></span>
	<span>özelliğini</span>
	<span class="text-primary pr-1 pl-1"><b>{{line.selected_customattribute_text_val}}</b></span>
	</template>



	<span>olarak değiştir</span>
</template>
<!-- custom_attribute affected-->
</p>

</div>



<div class="col-1">
 <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,line.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+line.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
	<Menu :id="'overlay_menu'+line.id" :ref="'menu'+line.id" :model="items" :popup="true">
	 <template #item="{item}">  
	  <template v-if="item.label=='Sil'">
	      <a class="p-menuitem-link" 
	      role="menuitem" 
	      @click="item.command(item.argument,{condition_id:line.id})"
	      >
	      <span :class="'p-menuitem-icon '+item.icon"></span>
	      <span class="p-menuitem-text">{{item.label}}</span>
	      <span class="p-ink"></span></a>
	  </template>
	  <template v-else>
	    <a class="p-menuitem-link" 
	      role="menuitem" 
	      @click="item.command(item.argument,{condition_id:line.id})"
	      >
	      <span :class="'p-menuitem-icon '+item.icon"></span>
	      <span class="p-menuitem-text">{{item.label}}</span>
	      <span class="p-ink"></span></a>
	  </template>

	</template>
	</Menu>
</div>



</div>






<hr>
</div>
</template>

<script>
export default {
  props:["line"],
  name: 'QuestionConditionLine',

  data () {
    return {
    		items: [
    		{
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"QuestionCondition",
                command: (argument,id) => {
                	console.log(argument)
                	console.log(id)
                  //return false
	                   this.gotoPage(argument,id)
	                }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:"inputfieldcondition",
                command: (argument,id) => {
                  console.log(argument)
                  console.log(id)
                  //return false
	                   this.deleteItem(argument,id)
	                }
            },

    	]
    }
  },
  computed:{
  	selected_custom_attribute_option()
  	{
  		let option = this.line.affectedcustomattribute.options.find((item)=>{return item.id == this.line.selected_customattribute_option_val})
  		return option
  	},
  	booleanval()
  	{
			if(this.line.selected_inputfield_switch_state===1)
			{
				return "Açık"
			}
			if(this.line.selected_inputfield_switch_state===0)
			{
				return "Kapalı"
			}
  	},
    conditionval()
    {
    	if(this.line.selected_inputfield_switch=="show_field")
	    {
	    	return '<span class="  pl-1"><b class="text-primary">Görünür</b> özelliğini</span>'
	    }
	    if(this.line.selected_inputfield_switch=="is_required")
	    {
	    	return '<span class="  pl-1"><b class="text-primary">Gerekli</b> özelliğini</span>'
	    }
	    if(this.line.selected_inputfield_switch=="is_nullable")
	    {
	    	return '<span class="  pl-1"><b class="text-primary">Boş Geçilebilir</b> özelliğini</span>'
	    }
	    if(this.line.selected_inputfield_switch=="points")
	    {
	    	return '<span class="  pl-1"><b class="text-primary">Puanını</b></span>'
	    }
    },
    pointoptions()
    {
    	if(this.line.selected_inputfield_points_option=="fixnumber")
    	{
    			return "olarak ayarla"
    	}
    	if(this.line.selected_inputfield_points_option=="addnumber")
    	{
    			return "ekleyerek güncelle"
    	}
    	if(this.line.selected_inputfield_points_option=="substractnumber")
    	{
    			return "çıkararak güncelle"
    	}
    	if(this.line.selected_inputfield_points_option=="multiplynumber")
    	{
    			return "ile çarparak güncelle"
    	}
    	if(this.line.selected_inputfield_points_option=="dividenumber")
    	{
    			return "ile bölerek güncelle"
    	}
    },
  },
  mounted()
  {
  },
  methods:{
  	gotoCondition()
  	{
  		this.$router.push({ name: 'QuestionCondition', params: { condition_id:this.line.id } })
  	},
  	toggle(event,id) {
      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
  }
}
</script>

<style lang="css" scoped>
</style>